import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=2d567419&scoped=true&"
import script from "./MediaPreview.vue?vue&type=script&lang=js&"
export * from "./MediaPreview.vue?vue&type=script&lang=js&"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&id=2d567419&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d567419",
  null
  
)

export default component.exports